export const downloadPDF = (url: string, filename: string): void => {
  fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/pdf",
    },
  })
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename || "bond"}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
};

export const handleValidate = (
  formRef: any,
  formData: any,
  formSchema: any,
  setState?: any
) => {
  if (formRef.current) {
    const { errorSchema, errors } = formRef.current.validate(
      formData,
      formSchema
    );
    if (setState) {
      setState(errorSchema);
    }
  }
};
